(function(){
'use strict';
var offset=Math.random()<0.5?0:1;
var colorIndex=0;
function choose(group,button){
 var card=group.closest('.card-wrapper');
 if(!card)return false;
 var image=card.querySelector('.card__media .media > img');
 if(!image)return false;
 image.src=button.dataset.image;
 if(button.dataset.productTitle)card.querySelectorAll('.card__heading a').forEach(function(link){link.textContent=button.dataset.productTitle.replace(/^Camiseta\s+/i,'');});
 image.removeAttribute('srcset');
 image.alt=button.dataset.color+' · '+(card.querySelector('.card__heading')?.textContent.trim()||'Camiseta');
 card.querySelectorAll('a[href]').forEach(function(link){link.href=button.dataset.url;});
 group.querySelectorAll('[data-bca-card-color-choice]').forEach(function(choice){choice.setAttribute('aria-pressed',String(choice===button));});
 return true;
}
function initColors(){
 if(/^Cobija\b/i.test(document.querySelector('h1')?.textContent.trim()||''))document.querySelectorAll('.product-form__input label').forEach(function(label){label.childNodes.forEach(function(node){if(node.nodeType===3&&/Mediana/i.test(node.textContent))node.textContent=node.textContent.replace(/Mediana/gi,'Viajera');});});
 document.querySelectorAll('[data-bca-color-card]:not([data-color-ready])').forEach(function(group){
  var buttons=group.querySelectorAll('[data-bca-card-color-choice]');
  if(!buttons.length)return;
  var initial=group.dataset.kind==='unit'?Array.from(buttons).find(function(b){return b.dataset.current==='true';}):null;
  if(choose(group,initial||buttons[group.dataset.kind==='blanket'?0:(colorIndex+offset)%buttons.length])){
   group.dataset.colorReady='true';colorIndex++;
  }
 });
}
document.addEventListener('click',function(event){
 var button=event.target.closest('[data-bca-card-color-choice]');
 if(!button){
  var action=event.target.closest('.bca-card-panel-link');
  var card=action&&action.closest('.card-wrapper');
  button=card&&card.querySelector('[data-bca-card-color-choice][aria-pressed="true"]');
 }
 if(!button)return;
 event.preventDefault();
 choose(button.closest('[data-bca-color-card]'),button);
 document.dispatchEvent(new CustomEvent('bca:choose-card-color',{detail:{button:button}}));
});
var pending=false;
function schedule(){if(pending)return;pending=true;requestAnimationFrame(function(){pending=false;initColors();});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initColors,{once:true});else initColors();
new MutationObserver(function(records){if(records.some(function(r){return r.addedNodes.length;}))schedule();}).observe(document.body,{childList:true,subtree:true});
})();
